import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";

type TokenReceivedArg = {
    autoRenew: boolean;
};

/**
 * Automatically renew OAuth token when it's about to expire.
 * We need it to prevent mass requests for the new token when signalR connection
 * is lost for all inactive users (because they don't send any requests to the server and as a result
 * don't renew their oauth tokens).
 */
export class OAuthTokenRenewer {
    private static _renewTimerId: number;

    public static onNewTokenRequesting() {
        this._stopRenewTimer();
    }

    public static onNewTokenReceived({ autoRenew }: TokenReceivedArg) {
        if (!autoRenew) {
            return;
        }

        this._renewTimerId = window.setInterval(() => {
            OAuthClient.getToken();
        }, 1000 * 30);
    }

    private static _stopRenewTimer() {
        if (this._renewTimerId) {
            window.clearInterval(this._renewTimerId);
        }
    }
}
